/* FOI-344: breadcrumb back links label themselves after the page the visitor
   came from. The previous page's title is recorded per tab by the tracker in
   theme.liquid; document.referrer guards against stale entries (new tab,
   external visit). With no usable same-site referrer the link keeps its
   server-rendered Home fallback. A referrer matching the current page (reload)
   or the section's Events crumb (data-pd-breadcrumb-events-url) is ignored so
   the trail never shows the same page twice. */
(function () {
  function humanize(pathname) {
    if (!pathname || pathname === '/') return 'Home';
    var segment = pathname.split('/').filter(Boolean).pop() || '';
    try {
      segment = decodeURIComponent(segment);
    } catch (e) {
      // keep the raw segment
    }
    segment = segment.replace(/[-_]+/g, ' ').trim();
    return segment.replace(/(^|\s)\S/g, function (c) {
      return c.toUpperCase();
    });
  }

  function previousPage() {
    try {
      return JSON.parse(sessionStorage.getItem('pd:nav-previous') || 'null');
    } catch (e) {
      return null;
    }
  }

  function init() {
    var links = document.querySelectorAll('[data-pd-breadcrumb-back]');
    if (!links.length) return;

    var referrer = null;
    try {
      if (document.referrer) referrer = new URL(document.referrer);
    } catch (e) {
      // ignore malformed referrers
    }
    var sameOrigin = !!referrer && referrer.origin === location.origin;

    links.forEach(function (link) {
      var useReferrer = sameOrigin && referrer.pathname !== location.pathname;

      if (useReferrer) {
        var eventsUrl = link.getAttribute('data-pd-breadcrumb-events-url');
        if (eventsUrl) {
          try {
            if (new URL(eventsUrl, location.origin).pathname === referrer.pathname) {
              useReferrer = false;
            }
          } catch (e) {
            // ignore malformed setting values
          }
        }
      }

      if (!useReferrer) return;

      var label = '';
      var prev = previousPage();
      if (prev && prev.title && prev.url) {
        try {
          if (new URL(prev.url).pathname === referrer.pathname) label = prev.title;
        } catch (e) {
          // fall through to the path-based label
        }
      }
      if (!label) label = humanize(referrer.pathname);

      // Page titles often end in a "| Brand" segment — drop it
      var pipe = label.lastIndexOf('|');
      if (pipe > 0) label = label.slice(0, pipe).trim();
      if (label.length > 40) label = label.slice(0, 39).trimEnd() + '…';

      link.setAttribute('href', document.referrer);
      link.textContent = label;

      link.addEventListener('click', function (e) {
        if (history.length > 1) {
          e.preventDefault();
          history.back();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
